"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTarget = void 0;

var _ = require("lodash");

var logger_1 = require("./logger");

var logger = logger_1.getInstance();

function getTarget(req, config) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var newTarget, router;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router = config.router;

            if (!_.isPlainObject(router)) {
              _context.next = 5;
              break;
            }

            newTarget = getTargetFromProxyTable(req, router);
            _context.next = 9;
            break;

          case 5:
            if (!_.isFunction(router)) {
              _context.next = 9;
              break;
            }

            _context.next = 8;
            return router(req);

          case 8:
            newTarget = _context.sent;

          case 9:
            return _context.abrupt("return", newTarget);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.getTarget = getTarget;

function getTargetFromProxyTable(req, table) {
  var result;
  var host = req.headers.host;
  var path = req.url;
  var hostAndPath = host + path;

  _.forIn(table, function (value, key) {
    if (containsPath(key)) {
      if (hostAndPath.indexOf(key) > -1) {
        // match 'localhost:3000/api'
        result = table[key];
        logger.debug('[HPM] Router table match: "%s"', key);
        return false;
      }
    } else {
      if (key === host) {
        // match 'localhost:3000'
        result = table[key];
        logger.debug('[HPM] Router table match: "%s"', host);
        return false;
      }
    }
  });

  return result;
}

function containsPath(v) {
  return v.indexOf('/') > -1;
}